import { RouterProvider } from 'react-router-dom';

// project imports
import router from 'routes';
import ThemeCustomization from 'themes';
import { PopupProvider } from 'contexts/PopupContext';
import GlobalLoader from 'components/ui/GlobalLoader';

// ==============================|| APP - THEME, ROUTER, LOCAL ||============================== //

export default function App() {
  return (
    <ThemeCustomization>
      <PopupProvider>
        <RouterProvider router={router} />
        <GlobalLoader />
      </PopupProvider>
    </ThemeCustomization>
  );
}
